import { render, staticRenderFns } from "./HomeGetCatalog.vue?vue&type=template&id=5f0d23ca&scoped=true&"
import script from "./HomeGetCatalog.vue?vue&type=script&lang=js&"
export * from "./HomeGetCatalog.vue?vue&type=script&lang=js&"
import style0 from "./HomeGetCatalog.vue?vue&type=style&index=0&id=5f0d23ca&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f0d23ca",
  null
  
)

export default component.exports